import { Layout, PtLine as PtLineComponent } from "components"
export const PtLine = () => {
 return (
  <Layout>
   <PtLineComponent />
  </Layout>
 )
}
